import { useFormat } from '@ideavivat/vivat-2';
import useWithdraw from '@/use/useWithdraw';

import { bomItemMaterialBrand } from './base';

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    'bom_item.job_no': {
      name: 'Job Sub',
      width: '6rem',
    },
    'bom_item.production_type': {
      name: 'ประเภท',
      width: '6rem',
    },
    material: {
      name: 'รหัสชิ้นส่วน',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.bom_item.material.code || '',
    },
    'bom_item.description': {
      name: 'รายละเอียด',
      width: '1fr',
    },
    bomItemMaterialBrand,
    'bom_item.drawing_no': {
      name: 'Drawing No./Part No.',
      width: '10rem',
    },
    amount: {
      name: 'จำนวนที่ขอเบิก / เบิกแล้ว',
      width: '10rem',
      class: {
        cell: 'text-right',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // filled_amount: {
    //   name: 'เบิกไปแล้ว',
    //   width: '5rem',
    //   class: {
    //     cell: 'text-center',
    //     text: 'text-right',
    //   },
    //   filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    // },
    // unit: {
    //   name: 'หน่วย',
    //   width: '5rem',
    //   class: 'text-left',
    // },
  },
};
